<template>
    <div class="login-container" style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      padding: 0.5em 2em;
      height: 100%;
    ">
        <FormHeader title="text.login_title" secondaryTitle="text.login_subtitle" />

        <div class="form" style="
        background-color: #ecf4f6;
        padding: 5%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
        margin: 2%;
        border-radius: 0.5em;
      ">
            <div class="otp-container">
                <input v-for="index in 6" :key="index" v-model="otp[index - 1]" class="otp-input" type="text"
                    maxlength="1" @input="onOtpInput($event, index)" ref="otpInput" />
            </div>
            <div class="otp-container-actions" v-if="!loading">
                <button :style="secondaryButtonStyles" @click="goBack">
                    <strong>Retour</strong>
                </button>
                <button v-if="!loading" :style="buttonStyles" @click="verifyCode"
                    :disabled="otp?.join('')?.length !== 6">
                    Continuer
                </button>
            </div>
            <div v-else style="display: flex; justify-content: center; align-items: center">
                <div class="loader-container">
                    <div class="loader"></div>
                </div>
            </div>
            <p v-if="submitError" style="
          color: red;
          font-size: 0.6em;
          display: flex;
          justify-content: center;
          align-items: center;
        ">
                <i>
                    {{
                        this.$i18n.t(submitError)
                    }}
                </i>
            </p>
        </div>
    </div>
</template>
<script>
import { customLogger } from "@/utils";
import FormHeader from "../customs/FormHeader_Formacast.vue";
export default {
    name: "LoginForm",
    components: {
        FormHeader,
    },
    props: {
        trigger: {
            type: Function,
            required: false,
            default: () => {
                customLogger("Redirect Called");
            },
        },
        /**
         * @param {string} redirect - name of the redirect to change to
         * @return {void}
         */
        redirect: {
            type: Function,
            required: false,
            default: () => {
                customLogger("Redirect Called");
            },
        },
        email: {
            type: String,
            required: true,
            default: ""
        },
        password: {
            type: String,
            required: true,
            default: ""
        }
    },
    data() {
        return {
            code: "",
            otp: Array(6).fill(''),
            submitError: null,
            validationErrors: {
                email: false,
                code: false
            },
            codePattern: /^[0-9]{6}$/,
            errorStyles: {
                color: "red",
                border: "1px solid red",
                borderRadius: "1em",
                transition: "0.3s ease-in-out",
            },
            defaultStyles: {
                transition: "0.3s ease-in-out",
                color: "#747474",
                border: "1px solid #747474",
                borderRadius: "1em",
                backgroundColor: "transparent",
            },
            loading: false,
        };
    },
    computed: {
        isFormValid() {
            return true
        },
        secondaryButtonStyles() {
            return {
                transition: "0.3s ease-in-out",
                backgroundColor: "transparent",
                padding: "10px 15px",
                color: "grey",
                borderRadius: "25px",
                margin: "0.5em auto",
                border: "none",
                cursor: this.isFormValid ? "pointer" : "default",
                width: "7em",
                border: "1px solid grey",
                textAlign: "center"
            };
        },
        buttonStyles() {
            return {
                transition: "0.3s ease-in-out",
                backgroundColor: this.isFormValid ? "#264c78" : "#d3d3d3",
                padding: "10px 15px",
                color: this.isFormValid ? "white" : "#a9a9a9",
                borderRadius: "25px",
                margin: "0.5em auto",
                border: "none",
                cursor: this.isFormValid ? "pointer" : "default",
                width: "15em",
                textAlign: "center"
            };
        },
    },
    watch: {
        otp: {
            handler: function (val) {
                if (val.join('').length === 6) {
                    this.verifyCode()
                }
            },
            deep: true
        },
        submitError: function (val) {
            if (val === "verify_otp.error.otp_incorrect") {
                this.submitError = "chat.otp_incorrect"
            }
        }
    },
    methods: {
        /**
         * @param {string} fieldName - name of the field to validate
         * @param {RegExp} pattern - pattern to validate the field against
         */
        validateField(fieldName, pattern) {
            if (!pattern.test(this[fieldName])) {
                this.$set(this.validationErrors, fieldName, true);
                setTimeout(
                    () => this.$set(this.validationErrors, fieldName, false),
                    5000
                );
            } else {
                this.$set(this.validationErrors, fieldName, false);
            }
        },
        async verifyCode() {
            const otpCode = this.otp.join('');
            if (!otpCode) return;
            this.loading = true;
            try {
                await this.$store.dispatch("VERIFY_OTP_EMAIL", {
                    email: this.email,
                    otp: otpCode,
                });
                const At = new Date();
                await this.$store.commit("PUSH_MESSAGE", {
                    sender_type: "bot",
                    message: "chat.welcome",
                    typing_indicator: false,
                    sent_at: At.toISOString(),
                });
                this.submitForm()
            } catch (error) {
                if (error.response?.status === 401) {
                    this.submitError = error.response.data.message
                }
                else {
                    this.submitError = "An error occurred while verifying OTP."
                }
                setTimeout(() => {
                    this.submitError = null
                }, 5000)
            }
            this.loading = false;
        },
        onOtpInput(event, index) {
            const value = event.target.value;
            this.otp[index - 1] = value.replace(/[^0-9]/g, '');
            if (value && index < 6) {
                this.$refs.otpInput[index].focus();
            }
        },
        goBack() {
            this.trigger()
        },
        async submitForm() {
            try {
                await this.$store.dispatch("SIGNIN_USER_BY_EMAIL", {
                    email: this.email,
                    password: this.password,
                });
                await this.$store.dispatch("FETCH_USER_DATA", true);
                this.$store.commit("SHOW_AUTH_FLOW", false);
                if (this.$store.state.user.data?.subscription?.subscribe) {
                    customLogger("User has a subscription");
                    this.$store.commit("SHOW_SUBS_FLOW", false);
                    await this.$store.dispatch("FETCH_USER_MESSAGES");
                    this.$eb.emit("BoxMounted");
                } else {
                    customLogger("User has no subscription");
                    this.$store.commit("SHOW_SUBS_FLOW", true);
                }
            } catch (e) {
                this.submitError = e?.data?.error || e.message || 'An unknown error occurred';
                customLogger(e);
            }
        },
    },
};
</script>